import { NppesPayloadData } from "../models/PhysicianDetails";
import { GetQueryString } from "../utils";
import API from "./api";

export const GetNPPESDetailsData = (
  configUrl: string,
  payload: NppesPayloadData
) => API.get(`${configUrl}api/master/Physician?${GetQueryString(payload)}`);
